import { render, staticRenderFns } from "./jyd.vue?vue&type=template&id=05464c1f&scoped=true&"
import script from "./jyd.vue?vue&type=script&lang=js&"
export * from "./jyd.vue?vue&type=script&lang=js&"
import style0 from "./jyd.vue?vue&type=style&index=0&id=05464c1f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05464c1f",
  null
  
)

export default component.exports